/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {__platform_browser_private__ as r, __platform_browser_private__ as t} from '@angular/platform-browser';

export var getDOM: typeof t.getDOM = r.getDOM;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
